// Payment requests
export const CHECK_LIST = "CHECK_LIST";
export const CHECK_FILTER = "CHECK_FILTER";
export const CHECK_UPDATE = "CHECK_UPDATE";
export const CONSIGNMENT_LIST = "CONSIGNMENT_LIST";
export const CONSIGNMENT_FILTER = "CONSIGNMENT_FILTER";
export const CONSIGNMENT_UPDATE = "CONSIGNMENT_UPDATE";

// Payment success
export const CHECK_LIST_SUCCESS = "CHECK_LIST_SUCCESS";
export const CHECK_UPDATE_SUCCESS = "CHECK_UPDATE_SUCCESS";
export const CONSIGNMENT_LIST_SUCCESS = "CONSIGNMENT_LIST_SUCCESS";
export const CONSIGNMENT_UPDATE_SUCCESS = "CONSIGNMENT_UPDATE_SUCCESS";

// Payment failed
export const PAYMENT_REQUEST_FAILED = "PAYMENT_REQUEST_FAILED";
